import React from "react";
import { Calendar, CheckCircle2 } from "lucide-react";
import { ConfettiCelebration } from "./ConfettiCelebration";

const LORA  = { fontFamily: "'Lora', Georgia, serif" };
const SERIF = { fontFamily: "'Cormorant Garamond', Georgia, serif" };

export function ProgressHeader({ tasks, dateDepart, isImminent, imminentMessage }) {
  const total = tasks.length;
  const completed = tasks.filter((t) => t.completed).length;
  const allDone = total > 0 && completed === total;
  const pct = total > 0 ? Math.round((completed / total) * 100) : 0;

  const daysLeft = React.useMemo(() => {
    if (!dateDepart) return null;
    try {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const depart = new Date(dateDepart);
      const diff = Math.round((depart - today) / 86400000);
      return diff;
    } catch {
      return null;
    }
  }, [dateDepart]);

  const uncompleted = total - completed;
  const blocking = tasks.filter((t) => !t.completed && t.bloquante).length;

  return (
    <div className="mb-6">
      {/* Countdown + task summary */}
      <div className="flex items-start justify-between mb-4">
        <div>
          {daysLeft !== null && (
            <div className="flex items-center gap-1.5 text-sm text-[#C17F59] mb-1" style={LORA}>
              <Calendar size={14} strokeWidth={1.5} />
              {daysLeft === 0
                ? "Départ aujourd'hui !"
                : daysLeft === 1
                ? "Départ demain"
                : `Départ dans ${daysLeft} jour${daysLeft > 1 ? "s" : ""}`}
            </div>
          )}
          {isImminent && imminentMessage && (
            <p className="text-xs text-amber-600 italic" style={LORA}>{imminentMessage}</p>
          )}
        </div>
        <div className="text-right">
          <p className="text-sm font-medium text-[#2B2623]" style={LORA}>
            {completed}<span className="text-[#9A8F86] font-normal"> / {total}</span>
          </p>
          <p className="text-xs text-[#9A8F86]" style={LORA}>complétées</p>
        </div>
      </div>

      {/* Progress bar */}
      <div className="w-full bg-[#DCD4C6] rounded-full h-2 mb-3 overflow-hidden">
        <div
          className="h-2 rounded-full transition-all duration-500"
          style={{ width: `${pct}%`, background: "#C17F59" }}
          data-testid="checklist-progress-bar"
        />
      </div>

      {/* Status message */}
      {allDone ? (
        <div
          className="flex items-center gap-2 justify-center py-3 bg-emerald-50 border border-emerald-200 rounded-sm text-emerald-700"
          data-testid="checklist-all-done"
        >
          <CheckCircle2 size={16} strokeWidth={1.5} />
          <span className="text-sm" style={{ ...LORA, fontWeight: 600 }}>
            Vous êtes prêt(e) pour l'aventure ! 🎒
          </span>
        </div>
      ) : (
        <div className="flex items-center gap-4 text-xs text-[#9A8F86]" style={LORA}>
          <span>{uncompleted} tâche{uncompleted > 1 ? "s" : ""} restante{uncompleted > 1 ? "s" : ""}</span>
          {blocking > 0 && (
            <span className="text-red-500">
              {blocking} bloquante{blocking > 1 ? "s" : ""}
            </span>
          )}
        </div>
      )}

      <ConfettiCelebration trigger={allDone} />
    </div>
  );
}
